function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round",
  strokeWidth: 2,
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#23C386",
  d: "M9 3v12M11.73 5.18H7.64a1.91 1.91 0 000 3.82h2.72a1.91 1.91 0 110 3.82H5.73"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 8.53,
  stroke: "#333"
}));

function SvgPricing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiPgogICAgPGxpbmUgeDE9IjkiIHgyPSI5IiB5MT0iMyIgeTI9IjE1IiBzdHJva2U9IiMyM0MzODYiLz4KICAgIDxwYXRoIHN0cm9rZT0iIzIzQzM4NiIgZD0iTTExLjczLDUuMTggTDcuNjQsNS4xOCBDNi41ODUxMzYxMyw1LjE4IDUuNzMsNi4wMzUxMzYxMyA1LjczLDcuMDkgQzUuNzMsOC4xNDQ4NjM4NyA2LjU4NTEzNjEzLDkgNy42NCw5IEwxMC4zNiw5IEMxMS40MTQ4NjM5LDkgMTIuMjcsOS44NTUxMzYxMyAxMi4yNywxMC45MSBDMTIuMjcsMTEuOTY0ODYzOSAxMS40MTQ4NjM5LDEyLjgyIDEwLjM2LDEyLjgyIEw1LjczLDEyLjgyIi8+CiAgICA8Y2lyY2xlIGN4PSI5IiBjeT0iOSIgcj0iOC41MyIgc3Ryb2tlPSIjMzMzIi8+CiAgPC9nPgo8L3N2Zz4K";
export { SvgPricing as ReactComponent };